import { graphql } from '@/__generated__';
import { useQuery } from '@apollo/client';
import { omit } from 'lodash-es';
import useTranslation from 'next-translate/useTranslation';
import React, { useCallback, useMemo } from 'react';
import { ModalDropdown } from '@/components/common/Modal/components';
import { DropdownProps } from '@/components/common/Modal/components/ModalDropdown';

interface LocationProps extends DropdownProps {
  selected?: string | null;
  city?: string;
  onChange?: (value: string | undefined, id: string | undefined) => void;
}

const GetProvince = graphql(`
  query Provinces {
    provinces {
      id
      name
      provinceId
    }
  }
`);

function RankingLocation({ onChange, ...props }: LocationProps) {
  const { data: provinceData } = useQuery(GetProvince, {});

  const { t } = useTranslation('common');
  const provinces = useMemo(() => {
    if (provinceData && provinceData?.provinces) {
      return provinceData?.provinces?.map((pv) => ({
        title: pv.name,
        value: pv.provinceId.toString(),
      }));
    }
    return [];
  }, [provinceData]);

  const handleChange = useCallback(
    (value: string | undefined, id: string | undefined) => {
      if (onChange) {
        onChange(value, id);
      }
    },
    [onChange],
  );

  return (
    <ModalDropdown
      items={provinces}
      hasSearchable
      focusOnOpen
      onSelect={handleChange}
      {...omit(props, 'items')}
      queryPlaceholder={t('label.search_city_placeholder')}
      placeholder={t('label.city_placeholder')}
      canClearSelected
    />
  );
}

export default RankingLocation;
